/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'card-stack-view-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M22.5 2h-19A1.5 1.5 0 0 0 2 3.5v18A1.5 1.5 0 0 0 3.5 23h19a1.5 1.5 0 0 0 1.5-1.5v-18A1.5 1.5 0 0 0 22.5 2zM12 19a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1zm7-2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1zm1-9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1z" fill-rule="evenodd"/>'
  }
})
